module.exports = __webpack_public_path__ + "static/media/img10.af10cc31.jpg";